import React from 'react';
import Footer from '../../components/Footer/Footer';

function PrivacyPolicy() {

    return (
        <div>
            <div className="w-[100vw] min-h-[100vh] p-5 text-white overflow-x-hidden">
                {/* HALF CIRCLE */}
                <div
                    className="absolute top-5 primary-bg rounded-l-full w-[150px] h-[300px] right-0 md:w-[200px] md:h-[400px] lg:w-[250px] lg:h-[500px]"
                    style={{
                        zIndex: 0
                    }}
                ></div>
                <div className="relative w-full h-full" style={{ zIndex: 1 }}>
                    {/* HEADING */}
                    <div className="w-full py-2 mb-5 pb-5 flex items-center justify-between">
                        <img src="/assets/images/logo/dodeal-white.png" alt="DoDeal Properties" className="w-[100px]" />
                        {/* <div className="text-xl md:text-2xl text-center uppercase primary-text">
                            Privacy Policy
                        </div> */}
                        <div className="font-bold uppercase text-3xl md:text-4xl lg:text-5xl xl:text-6xl mt-5 text-end w-[350px] md:w-[550px] lg:w-[750px] xl:w-[950px]">
                            Privacy Policy
                        </div>
                    </div>
                    {/* CONTENT */}
                    <div className="my-5 py-5 text-base flex flex-col gap-8">
                        <div>
                            At DODEAL, we value the privacy of our users and customers. This Privacy Policy outlines how we collect, use, and protect your personal information when you visit or use our services.
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Information We Collect
                            </div>
                            <div>
                                We collect the following types of information to provide and improve our services:
                                <li>
                                    <strong>Personal Information</strong>: When you create an account or contact us, we may collect your name, email address, phone number, and other relevant information.
                                </li>
                                <li>
                                    <strong>Usage Data</strong>: We collect data on how our services are used, including your interactions with our website and CRM platform. This can include IP addresses, browser types, device information, and activity logs.
                                </li>
                                <li>
                                    <strong>Property Listings Data</strong>: If you use DODEAL Properties, we collect information related to property listings, including property details, images, and contact information for inquiries.
                                </li>
                                {/* <li>
                                    <strong></strong>
                                </li> */}
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                How We Use Your Information
                            </div>
                            <div>
                                <li>
                                    <strong>To Provide Services</strong>: We use your information to deliver marketing services such as SEO, campaigns, ads, and social media management, and to manage property listings and inquiries.
                                </li>
                                <li>
                                    <strong>To Improve Our Services</strong>: We analyze usage data to enhance our website, mobile apps, CRM, and other services.
                                </li>
                                <li>
                                    <strong>Communication</strong>: We may use your contact details to send you updates, offers, or relevant information about our services.
                                </li>
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                How We Protect Your Information
                            </div>
                            <div>
                                We take the security of your personal data seriously and implement industry-standard measures to protect it. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Sharing Your Information
                            </div>
                            <div>
                                We do not share your personal information with third parties except in the following cases:
                                <li>
                                    <strong>Service Providers</strong>: We may share your information with third-party service providers who help us operate our business (e.g., hosting providers, analytics tools).
                                </li>
                                <li>
                                    <strong>Legal Compliance</strong>: We may disclose your information if required by law or to comply with a legal process.
                                </li>
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Cookies and Tracking Technologies
                            </div>
                            <div>
                                We use cookies and similar tracking technologies to enhance your experience on our website. These technologies help us analyze website traffic, personalize content, and track user behavior. You can control cookie settings through your browser preferences.
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Your Rights
                            </div>
                            <div>
                                You have the right to:
                                <li>Access the personal data we hold about you.</li>
                                <li>Request correction or deletion of your personal data.</li>
                                <li>Opt out of marketing communications. To exercise these rights, please contact us at <span className="primary-text">contact@dodeal.com</span></li>
                            </div>
                        </div>
                        <div>
                            <div className="font-bold primary-text mb-2">
                                Contacting us
                            </div>
                            <div>
                                Any changes we make to this policy in the future will be posted on this page. If you have any questions regarding this privacy policy, you may contact us.
                            </div>
                        </div>
                        <div>
                            Feel free to adjust any section or add more specific details as needed.
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default PrivacyPolicy;
